var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 21.375H20C21.1046 21.375 22 20.4796 22 19.375V9.375C22 8.2704 21.1046 7.375 20 7.375H17.75V5.375C17.75 3.8584 16.5166 2.625 15 2.625H9C7.4834 2.625 6.25 3.8584 6.25 5.375V7.375H4C2.8954 7.375 2 8.2704 2 9.375V19.375C2 20.4796 2.8954 21.375 4 21.375ZM7.75 5.375C7.75 4.6855 8.3105 4.125 9 4.125H15C15.6895 4.125 16.25 4.6855 16.25 5.375V7.375H7.75V5.375Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrands);
export default __webpack_public_path__ + "static/media/brands.7e123c27820ab713a1ddb4044aede3f5.svg";
export { ForwardRef as ReactComponent };